import Vue from 'vue';
import App from '@/App.vue';
import '@/registerServiceWorker';
import '@/oweb.boot';
import app from './app';

Object.freeze(app);

new Vue({
	render: h => h(App)
}).$mount('#app');
